export default {"src":"/_next/static/media/definiteProccess.27f82510.svg","height":103,"width":93,"blurWidth":0,"blurHeight":0};